/** Basic information about a dataset */
export interface IInfo {
    tlmID: string;
    alias: string;
    units: string;
}

/** Basic information about a dataset variable */
export interface IChartVariable {
    name: string;
    alias: string;
    units: string;
    length: number;
    type: string;
}

/** A component of dataset limits. Can be a red/yellow limit. If a point is outside the defined limtis there is a problem */
export interface ILimit {
    low: number;
    high: number;
}

export interface ILimits {
    exist?: boolean;
    red?: {
        low: number,
        high: number
    };
    yellow?: {
        low: number,
        high: number
    };
}

/** A type conversion maps a data number (dn) to a string */
export interface ITypeConversions {
    value: number;
    state: string;
    desirability: string;
}

/** Infamously, data about the data from LATIS */
export class Metadata {
    description: string;
    independentVariable: IChartVariable;
    info: IInfo;
    limits: ILimits;
    typeConversions: ITypeConversions[] = [];

    /** We get metadata from latis, so we can set this from that returned object */
    constructor( public name: string, xName: string, metadata: any ) {
        const yMeta = metadata[ name ];
        const xMeta = metadata[ xName ];
        this.description =  ( yMeta.long_name ? yMeta.long_name : undefined );
        if ( xMeta ) {
            this.independentVariable = {
                name: xName,
                alias: ( xMeta.alias ? xMeta.alias : undefined ),
                units: ( xMeta.units ? xMeta.units : undefined ),
                length: ( xMeta.length ? xMeta.length : undefined ),
                type: ( xMeta.type ? xMeta.type : undefined )
            };
        }
        this.info = {
            tlmID: ( yMeta.tlmId ? yMeta.tlmId : undefined ),
            alias: ( yMeta.alias ? yMeta.alias : undefined ),
            units: ( yMeta.units ? yMeta.units : undefined )
        };

        // If limits exist, add Limits to the metadata object
        if ( yMeta.limits ) {
            this.limits = {
                exist: true,
                yellow: {
                    low: yMeta.limits.yellow.low,
                    high: yMeta.limits.yellow.high
                },
                red: {
                    low: yMeta.limits.red.low,
                    high: yMeta.limits.red.high
                }
            };
        } else {
            this.limits = {
                exist: false
            };
        }

        // If analog conversions exist, add to the metadata object
        if ( yMeta.state_conversions ) {
            // sort by ascending numeric value
            this.typeConversions = yMeta.state_conversions.sort( (a, b) => {
                return a.value - b.value;
            });
        }
    }
}
